import React from "react"
import DashboardPill from "../components/dashboard-pill"

export default [
  {
    name: "S/N",
    sortable: true,
    maxWidth: "80px",
    minWidth: "50px",
    selector: "index",
  },
  {
    name: "Order ID",
    sortable: false,
    selector: "orderid",
    minWidth: "90px",
    maxWidth: "120px",
  },
  {
    name: "Status",
    sortable: false,
    selector: row =>
      row.reason === "Approved" ? (
        <DashboardPill
          icon={<i className="fas fa-fw fa-money-check" />}
          type={"Approved"}
        >
          Approved
        </DashboardPill>
      ) : (
        <DashboardPill
          icon={<i className="fas fa-fw fa-money-check" />}
          type={"Declined"}
        >
          {row.reason}
        </DashboardPill>
      ),
    minWidth: "230px",
    maxWidth: "350px",
  },
]



// WEBPACK FOOTER //
// ./src/utils/orderModel.js